import React from "react";
import PropTypes from "prop-types";
import ErrorComponent from "../components/general/components/error/ErrorComponent";

function Error(props) {
  return (
    <>
      <ErrorComponent {...props}></ErrorComponent>
    </>
  );
}
Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : null;
  const urlInfo = res && res.req ? res.req.url : null;
  return { statusCode, err, urlInfo };
};
export default Error;

Error.propTypes = { statusCode: PropTypes.number, hostname: PropTypes.string };

// `An error ${statusCode} occurred on server`
